import React, { useMemo, useState } from 'react';
import icPasswordVision1 from 'Assets/img/sign/ic_password_vision.png';
import icPasswordVision2 from 'Assets/img/sign/ic_password_vision@2x.png';
import icPasswordVision3 from 'Assets/img/sign/ic_password_vision@3x.png';
import icPasswordVisionNot1 from 'Assets/img/sign/ic_password_vision_not.png';
import icPasswordVisionNot2 from 'Assets/img/sign/ic_password_vision_not@2x.png';
import icPasswordVisionNot3 from 'Assets/img/sign/ic_password_vision_not@3x.png';
import { getImageSet } from 'Util/DataUtils';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import { useIntl } from 'react-intl';

const icPasswordVision = getImageSet([icPasswordVision1, icPasswordVision2, icPasswordVision3]);
const icPasswordVisionNot = getImageSet([icPasswordVisionNot1, icPasswordVisionNot2, icPasswordVisionNot3]);

const TextInput = ({ value, onChange, label, placeholder: propsPlaceholder, isError = false, errorText, isPassword = false, isShowPlaceholder = false, tabIndex = 0, ...props }) => {
  const { formatMessage } = useIntl();

  const [showPassword, setShowPassword] = useState(false);
  const [isFocus, setIsFocus] = useState(false);
  const placeholder = useMemo(() => {
    if (propsPlaceholder === undefined) return label;
    if (isShowPlaceholder) return propsPlaceholder;
    if (!isFocus) return label;
    return propsPlaceholder;
  }, [isFocus, label, propsPlaceholder, isShowPlaceholder]);
  return (
    <FormControl
      error={isError}
      fullWidth
      variant="outlined"
      sx={{
        '& label': {
          color: '#000',
          fontFamily: 'Pretendard',
        },
        '& label.Mui-focused': {
          color: '#000',
        },
        '& label.Mui-error': {
          color: '#000',
        },

        '& .MuiOutlinedInput-root': {
          fieldset: {
            borderRadius: '10px',
            border: '1px solid #ddd',
          },
          '&:hover fieldset': {
            borderColor: '#000',
          },
          '&.Mui-focused fieldset': {
            border: '1px solid #000',
          },
          '&.Mui-error fieldset': {
            border: '1px solid #FF4B4B',
          },
        },
      }}
    >
      {(isFocus || value) && <InputLabel htmlFor={label}>{formatMessage({ id: label })}</InputLabel>}
      <OutlinedInput
        autoComplete="new-password"
        id={label}
        value={value}
        onChange={onChange}
        type={isPassword ? (showPassword ? 'text' : 'password') : 'text'}
        placeholder={formatMessage({ id: placeholder })}
        endAdornment={
          isPassword && (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowPassword(x => !x)} edge="end">
                {isPassword && <img {...(showPassword ? icPasswordVisionNot : icPasswordVision)} alt="vision" />}
              </IconButton>
            </InputAdornment>
          )
        }
        label={formatMessage({ id: label })}
        onFocus={() => {
          setIsFocus(true);
        }}
        onBlur={() => {
          setIsFocus(false);
        }}
        inputProps={{
          style: {
            color: '#222',
            fontFamily: 'Pretendard',
            fontSize: '15px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
            padding: '15px',
          },
          tabIndex,
        }}
        {...props}
      />
      {isError && errorText && <div className="error-text">{errorText}</div>}
    </FormControl>
  );
};

export default TextInput;
